module.exports = __webpack_public_path__ + "static/media/JM_iconos-06_pantalla-compl.48ba52ca.svg";